import { readOnly } from '@ember/object/computed';
import Service, { inject as service } from '@ember/service';
import { PAYOUT__SH_PAYMENT_INCLUDES } from "../../../../../../constants/routes/admin/accounting/payout";

export default Service.extend({
  /**
   * Register Services
   */
  applicationStateManager: service('state-managers/application'),
  session: service(),
  shPaymentCommandService : service('commands/sh-payment-commands'),
  shPaymentTransactionCommandService: service('commands/sh-payment-transaction-commands'),
  state: service('states/routes/admin/accounting/payout/sh-payment'),
  store: service(),

  currentUser: readOnly('session.currentUser'),

  /**
   * Update state after fees have been updated
   *
   * @param bool|null madeFMS
   */
  feesUpdated(madeFMS = null) {
    this.applicationStateManager.addToast('Fees updated');

    this.loadShPayment(this.get('state.shPayment.id'));
  },

  /**
   * User has successfully added a line item, update state
   */
  lineItemAdded() {
    this.loadShPayment(this.get('state.shPayment.id'));
  },

  /**
   * User has successfully updated a line item, update state
   */
  lineItemEdited() {
    this.loadShPayment(this.get('state.shPayment.id'));
  },

  /**
   * Load the payment for the view and set the state.
   *
   * @param {String} shPaymentId
   * @return {*}
   */
  loadShPayment(shPaymentId) {
    this.set('state.isLoadingPayment', true);

    return this.get('shPaymentCommandService').loadShPayment(
      shPaymentId,
      PAYOUT__SH_PAYMENT_INCLUDES
    ).then(shPayment => {
      this.set('state.shPayment', shPayment);
    }).catch(() => {
      // gobble gobble
    }).finally(() => this.set('state.isLoadingPayment', false));
  },

  /**
   * Release a ShPayment and send it to the user.
   */
  releasePayment() {
    this.set('state.isLoadingPayment', true);

    this.get('shPaymentCommandService').releasePayment(
      this.get('state.shPayment')
    ).then(() => {
      this.set('state.isLoadingPayment', false);
      this.loadShPayment(this.get('state.shPayment.id')).catch(() => {
        // gobble gobble
      });
    }).catch(() => {
      // gobble gobble

      this.set('state.isLoadingPayment', false);
    });
  },

  /**
   * After a payment transaction has been edited.
   */
  shPaymentTransactionEdited() {
    this.loadShPayment(this.get('state.shPayment.id'));
  },

  /**
   * @param {ShPaymentTransaction} shPaymentTransaction
   * @return {Promise<*>}
   */
  deleteTransaction(shPaymentTransaction) {
    this.set('state.isLoadingPayment', true);

    return this.get('shPaymentTransactionCommandService').deleteTransaction(shPaymentTransaction).then(() => {
      return this.get('shPaymentCommandService').loadShPayment(this.get('state.shPayment.id'), PAYOUT__SH_PAYMENT_INCLUDES);
    }).then(() => {
      shPaymentTransaction.unloadRecord();
    }).finally(() => {
      this.set('state.isLoadingPayment', false);
    });
  },
});
